import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Card, CardBody, Progress,CardHeader,Table,TabContent, TabPane, Nav, NavItem, NavLink} from "reactstrap";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';

const propTypes = {
    voltageab: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    voltageabvalue: PropTypes.string,
    voltagebcvalue: PropTypes.string,
    voltagecavalue: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    invert: PropTypes.bool
};

const defaultProps = {
    voltageab: '87.500',
    icon: "fa-bar-chart",
    color: 'info',
    voltageabvalue: "25",
    voltagebcvalue: "25",
    voltagecavalue: "25",
    children: "Visitors",
    invert: false
};

class Generator extends Component {
    render() {
        const {className, cssModule, voltageab, voltagebc, voltageca, icon, color, voltageabvalue, voltagebcvalue, voltagecavalue, children, invert, ...attributes} = this.props;


        const progress = {style: "", color: color, voltageabvalue: voltageabvalue, voltagebcvalue: voltagebcvalue, voltagecavalue: voltagecavalue};
        const card = {style: "", bgColor: "", icon: icon};

        if (invert) {
            progress.style = "progress-white";
            progress.color = "";
            card.style = "text-white";
            card.bgColor = 'bg-' + color;
        }


        const classes = mapToCssModules(classNames(className, card.style, card.bgColor), cssModule);
        progress.style = classNames("progress-xs mt-3 mb-0", progress.style);

        return (
            <Card className={ classes } {...attributes}>
                <CardHeader>
                    {children}
                </CardHeader>
                <CardBody className="card-body">
                    <Table hover responsive className="table-outline d-sm-table bg-white">
                        <thead>
                        <tr>
                            <th className="text-center" colSpan="2" >Generator  Pre Alarms</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <small className="text-muted text-uppercase font-weight-bold">Voltage AB</small>
                            </td>
                            <td>
                                { voltageab }
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <small className="text-muted text-uppercase font-weight-bold">Voltage BC</small>
                            </td>
                            <td>
                                { voltageab }
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <small className="text-muted text-uppercase font-weight-bold">Voltage CA</small>
                            </td>
                            <td>
                                { voltageab }
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}><Progress className={ progress.style } color={ progress.color } value={ progress.voltagecavalue }/></td>
                        </tr>
                        </tbody>

                    </Table>
                    <div className="h6 mb-0">{ voltageab }</div>
                    <small className="text-muted text-uppercase font-weight-bold">Voltage AB</small>
                    <p></p>
                    <div className="h6 mb-0">{ voltagebc }</div>
                    <small className="text-muted text-uppercase font-weight-bold">Voltage BC</small>
                    <p></p>
                    <div className="h6 mb-0">{ voltageca }</div>
                    <small className="text-muted text-uppercase font-weight-bold">Voltage CA</small>
                    <p></p>
                    <div className="h6 mb-0">{ voltageca }</div>
                    <small className="text-muted text-uppercase font-weight-bold">Voltage Avg</small>
                    <Progress className={ progress.style } color={ progress.color } value={ progress.voltagecavalue }/>
                </CardBody>
            </Card>
        )
    }
}

Generator.propTypes = propTypes;
Generator.defaultProps = defaultProps;

export default Generator;


// WEBPACK FOOTER //
// ./src/views/site/GeneratorSchema/Generator.js